export enum CompanyNameValidationStatus {
    FREE = 'FREE',
    OCCUPIED = `OCCUPIED`,
    ERROR = `ERROR`,
    SENSITIVE = `SENSITIVE`
}

export enum LegalEntityType {
    COMMERCIAL = 'COMMERCIAL',
    NON_COMMERCIAL = 'NON_COMMERCIAL'
}

export enum BusinessSize {
    SMALL = 'SMALL',
    MEDIUM = 'MEDIUM',
    LARGE = 'LARGE'
}

export enum FormOfRecognisedCompany {
    BRANCH = 'BRANCH',
    REPRESENTATIVE_OFFICE = 'REPRESENTATIVE_OFFICE'
}

export enum InvestmentBusinessActivityType {
    OPEN_ENDED = 'OPEN_ENDED',
    CLOSE_ENDED = 'CLOSE_ENDED'
}

export const INVESTMENT_BUSINESS_ACTIVITY_MAP: Map<InvestmentBusinessActivityType, string> = new Map([
    [InvestmentBusinessActivityType.OPEN_ENDED, 'Open-Ended'],
    [InvestmentBusinessActivityType.CLOSE_ENDED, 'Close-Ended'],
])
